@if (dataSignal(); as data) {
  @if (data.image) {
    <cx-media class="banner desktop-only" [container]="data.image"></cx-media>
  }
  @if (data.title) {
    <h2 [style.color]="color">{{ data.title }}</h2>
  }
  @if (data.textField1) {
    <p [style.color]="color">{{ data.textField1 }}</p>
  }
}
